/**
 * 将接口返回的图例列表解析为地图使用的 MappingTable 格式
 * @param {Array} list 接口返回的 list 数据
 * @returns {Object} 解析后的 MappingTable
 */
export const parseMappingData = (list) => {
  if (!list || !Array.isArray(list)) return {};
  const mapping = {};
  list.forEach(item => {
    let icon = '';
    if (item.type === 'line') {
      const match = (item.styleValue || '').match(/strokecolor:([^;]+)/);
      icon = match ? `color:${match[1]}` : 'color:#409EFF';
    } else {
      icon = item.styleValue;
    }
    mapping[item.legendName] = {
      icon: icon,
      defaultShow: item.defaultShow,
      config: item.config,
      type: item.type, // 保存类型信息，用于区分点和线
      styleValue: item.styleValue // 保存样式值，用于线图层样式解析
    };
  });
  return mapping;
};

// 默认基础配置
const MappingTable = {

};

export default MappingTable;
